import { render, staticRenderFns } from "./CompanyNav.vue?vue&type=template&id=f808dbba&scoped=true"
import script from "./CompanyNav.vue?vue&type=script&lang=ts"
export * from "./CompanyNav.vue?vue&type=script&lang=ts"
import style0 from "./CompanyNav.vue?vue&type=style&index=0&id=f808dbba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808dbba",
  null
  
)

export default component.exports